import baseUrl from '../baseUrl.ts';
import {handleResponse} from '../handleResponse.ts';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch.ts';

// Mirrors GptAssistant/Voice/VoiceScreenshotDescriptionService.cs.

export interface DescribeScreenshotRequest {
    imageDataUrl: string;
    question: string;
    snapshotText?: string;
    pageTitle?: string;
    pageUrl?: string;
    isRegion?: boolean;
}

export interface DescribeScreenshotResponse {
    /** Answer first, then the detail on screen, one item per line. */
    description: string;
    /** The opening answer alone; the part worth reading aloud. */
    spokenAnswer: string;
    model: string;
}

/**
 * Ask a vision model what a screenshot of the browser tab shows. One call,
 * nothing stored; the voice assistant uses the text to orient itself.
 */
export const describeScreenshot = async (
    authenticatedFetch: ReturnType<typeof useCreateAuthenticatedFetch>,
    request: DescribeScreenshotRequest
): Promise<DescribeScreenshotResponse> => {
    const response = await authenticatedFetch(
        `${baseUrl}/api/voice/describe-screenshot`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(request)
        }
    );
    return handleResponse(response);
};
